module.exports = __webpack_public_path__ + "img/knue_gallery7.a952b8ca.jpg";